import confetti from '../../utils/confetti';

class CartShipping extends HTMLElement {
  constructor() {
    super();

    this.total = Number(this.querySelector('[data-cart-total]')?.dataset?.cartTotal) / 100 || 0; // Total price of the cart
    // The threshold is resolved per-market server-side and passed via
    // data-free-shipping-threshold. 0 means the market offers free shipping
    // always. (The legacy window.theme international override was dropped here:
    // it clobbered the market value and broke always-free markets.)
    this.threshold = Number(this.dataset.freeShippingThreshold);
    this.remaining = this.threshold - this.total;
    this.onlyGiveX = false;
    this.confettiFired = false;
  }

  connectedCallback() {
    this.initializeComponent();
  }

  getCartTotal() {
    return Number(this.querySelector('[data-cart-total]')?.dataset?.cartTotal) / 100 || 0;
  }

  setProgressBar() {
    const progressContainer = this.querySelector('.FreeShippingBar__progress-container');
    if (!progressContainer) return;

    if (this.threshold === 0 || this.onlyGiveX) {
      this.fireConfetti();
      return (progressContainer.style.display = 'none');
    }
    if (progressContainer.style.display === 'none') {
      progressContainer.style.display = '';
      this.fireConfetti(); // this will be called to reset the confettiFired flag if it is necessary
    }

    // threshold === 0 means free shipping always: the cart total (>= 0) always
    // meets it, so progressRatio is 1 (full bar) and the divide is never hit.
    const progressRatio = this.total >= this.threshold ? 1 : this.total / this.threshold;
    const progressPercentage = progressRatio * 100;

    const freeShippingProgressBar = this.querySelector('.FreeShippingBar__progress');
    if (!freeShippingProgressBar) return;

    // Deferring the confetti firing until the progress bar transition ends
    freeShippingProgressBar.addEventListener('transitionend', () => this.fireConfetti());

    freeShippingProgressBar.style.transform = `translate3d(-${100 - progressPercentage}%, 0, 0)`;

    if (this.remaining <= 0) {
      freeShippingProgressBar.style.background = '#60269E';
    } else {
      freeShippingProgressBar.style.background = '#92959B';
    }
  }

  fireConfetti() {
    // Go off confetti if the remaining is 0 or less than 0 or if the cart got into onlyGivex mode
    // the onlyGivex mode is set when the cart has only GIVEX products or threshold is 0
    if (!this.confettiFired && (this.remaining <= 0 || this.threshold === 0 || this.onlyGiveX)) {
      const confettiPot = document.getElementById('confetti-canvas'); // custom canvas
      const confettiObj = confetti.create(confettiPot, { resize: true });

      confettiObj({ origin: { y: 0.7 } });
      this.confettiFired = true;
    } else if (this.confettiFired && !this.onlyGiveX && this.threshold !== 0 && this.remaining > 0) {
      this.confettiFired = false;
    }

    this.querySelector('.FreeShippingBar__progress').removeEventListener('transitionend', this.fireConfetti);
  }

  updateProgressBar(mutationList) {
    for (const mutation of mutationList) {
      if (mutation.type === 'childList') {
        if (mutation.target.querySelector('[data-cart-total]')) {
          // Set this.onlyGivex if the cart has only giveX products
          const hasOnlyGiveX = this.querySelector('[has-only-givex]');
          if (hasOnlyGiveX) {
            this.onlyGiveX = true;
          } else {
            this.onlyGiveX = false;
          }

          this.total = this.getCartTotal();
          this.remaining = this.threshold - this.total;

          this.setProgressBar(); // Update progress bar
        }
      }
    }
  }

  initializeComponent() {
    const hasOnlyGiveX = this.querySelector('[has-only-givex]');
    if (hasOnlyGiveX) {
      this.onlyGiveX = true;
    }

    this.setProgressBar();

    const targetNode = document.getElementById('free-shipping-container');
    if (!targetNode) return;

    const config = { attributes: true, childList: true, subtree: true };
    const observer = new MutationObserver(this.updateProgressBar.bind(this));
    observer.observe(targetNode, config);
  }
}

export default CartShipping;
